<template>
  <list-item>
    <template #actions>
      <div class="operationBtnDiv" style="display: flex;align-items: center;"
           v-for="btnItem in sectionConfig.operationList">
        <div class="common-link" :key="btnItem.value"><span v-if="btnItem.icon" :class="btnItem.icon" style="padding-right: 3px;"></span>{{ t(btnItem.label) }}</div>
      </div>
    </template>
      <list-item-meta
        :description="dataConfig.showCols.desCol&&dataConfig.showCols.desCol&&record[dataConfig.showCols.desCol.propId]"
      >
        <template #title>

          <link-text :record="record"
                     :showCols="dataConfig.showCols"
                     propName="titleCol"
                     :dataConfig="dataConfig"></link-text>

        </template>
        <template #avatar>

          <Avatar  v-if="dataConfig.showCols.userImgCol&&dataConfig.showCols.userImgCol.showFlag!==false">
            <template #icon>
              <a-image
                v-if="dataConfig.showCols.userImgCol&&record[dataConfig.showCols.userImgCol.propId]"
                :width="40"
                :src="(dataConfig.showCols.userImgCol&&record[dataConfig.showCols.userImgCol.propId])"
              />
              <span class="user-icon-span" style="display: inline-block;position: relative;top:-3px;" v-else>
               <UserOutlined />
            </span>
            </template>
          </Avatar>

        </template>
      </list-item-meta>
  </list-item>
</template>


<script lang="ts">
import {defineComponent} from 'vue';
import {ListItem, ListItemMeta, Avatar, Popconfirm} from 'ant-design-vue';
import i18n from '@/i18n';

export default defineComponent({
  components: {
    Avatar,
    ListItemMeta,
    Popconfirm,
    ListItem
  },
  columns: [
    {value: 'title', label: i18n.global.t('标题信息')},
    {value: 'description', label: i18n.global.t('描述信息')},
    {value: 'userHeaderUrl', label: i18n.global.t('图片')},
  ],
  label: i18n.global.t('用户说明信息编辑'),
  name: 'userList',
});
</script>
<script lang="ts" setup>
import {Image as AImage,Button as AButton,Modal as AModal,Table as ATable} from 'ant-design-vue';
import {UserOutlined} from "@ant-design/icons-vue";
import LinkText from "@/gateway-main/commonVue/link-text.vue";
import {useI18n} from "vue-i18n";
import {toRefs} from "vue";

const {t} = useI18n();


interface propTypes {
  record: any,
  dataConfig: any,
  sectionConfig:any,
  dateCol: any
};
const props = withDefaults(defineProps<propTypes>(), {
  record: {},
  sectionConfig:{},
  dataConfig: {},
  dateCol: {}
})
const {dataConfig} = toRefs(props);
if (unref(dataConfig)["showCols"] == null) {
  unref(dataConfig)["showCols"] = {
    desCol: {},
    titleCol: {},
    userImgCol: {}
  };
}
const delRecord = () => {
}
</script>

